import { c as _c } from "react/compiler-runtime";
import { Box, Button, Separator, Flex, Heading, HStack, Image, Stack, VStack } from '@chakra-ui/react';
import { CardCarousel } from '@src/components/sco/CardCarousel';
import { MobileBottomControl } from '@src/components/sco/CardCarousel/Controls/MobileBottomControl';
import { QuoteBlock } from '@src/components/sco/SuccessLP/QuoteBlock';
import { SocialProofFeatureCard } from '@src/components/sco/SuccessLP/SocialProofFeatureCard';
import { SocialProofMasterclassCard } from '@src/components/sco/SuccessLP/SocialProofMasterclassCard';
import { ChevronRightIcon } from '@src/components/sco/icons';
import { useBreakpointContext } from '@src/components/sco/utilities/BreakpointProvider';
import { NextLink } from '@src/components/sco/utilities/NextLink';
export const FoundersBlock: React.FC = () => {
  const $ = _c(68);
  const {
    getBreakpointValue
  } = useBreakpointContext();
  let t0;
  if ($[0] !== getBreakpointValue) {
    t0 = getBreakpointValue([true, true, false, false, false]);
    $[0] = getBreakpointValue;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isMobile = t0;
  let t1;
  if ($[2] !== getBreakpointValue) {
    t1 = getBreakpointValue([false, false, true, false, false]);
    $[2] = getBreakpointValue;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const isTablet = t1;
  let t2;
  if ($[4] !== getBreakpointValue) {
    t2 = getBreakpointValue([4, 4, 10, 10, 10]);
    $[4] = getBreakpointValue;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Separator flex="1" />;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== getBreakpointValue) {
    t4 = getBreakpointValue(["xl", "2xl", "3xl"]);
    $[7] = getBreakpointValue;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <Heading color="purple.fg" letterSpacing="wide" size={t4} textAlign="center" textTransform="uppercase">Founders</Heading>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <Separator flex="1" />;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5) {
    t7 = <HStack align="center" gap={10} justify="center" width="full">{t3}{t5}{t6}</HStack>;
    $[12] = t5;
    $[13] = t7;
  } else {
    t7 = $[13];
  }
  let t8;
  if ($[14] !== getBreakpointValue) {
    t8 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[14] = getBreakpointValue;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  let t9;
  if ($[16] !== t8) {
    t9 = <Heading color="red.fg" size={t8} textAlign="center">The most successful Founders have inspired us with their stories</Heading>;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t7 || $[19] !== t9) {
    t10 = <VStack align="center" gap={10} justify="center" maxWidth="container.xl" width="full">{t7}{t9}</VStack>;
    $[18] = t7;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== getBreakpointValue) {
    t11 = getBreakpointValue(["column", "column", "row"]);
    $[21] = getBreakpointValue;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  const t12 = isMobile ? 16 : 0;
  let t13;
  if ($[23] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = require("@public/assets/graphics/avatars/brian-chesky-avatar.png");
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  const t14 = t13.default.src;
  let t15;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = require("@public/assets/graphics/client-logos/airbnb-logo-white.svg");
    $[24] = t15;
  } else {
    t15 = $[24];
  }
  let t16;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <QuoteBlock avatarUrl={t14} logoAlt="AirBnB Logo" logoUrl={t15.default.src} logoWidth="180px" name="Brian Chesky" title="Founder, AirBnB" quote={"My Dad just said \u201CMake sure one day you get a job with health insurance, and do not come back to our basement, please.\u201D"} quoteTextProps={{
      maxWidth: "30rem"
    }} />;
    $[25] = t16;
  } else {
    t16 = $[25];
  }
  let t17;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t17 = <Box><Button asChild={true} size="lg" variant="outline"><NextLink href="https://www.startups.com/founder-interviews/brian-chesky" target="_blank">Read Brian's Story<ChevronRightIcon /></NextLink></Button></Box>;
    $[26] = t17;
  } else {
    t17 = $[26];
  }
  let t18;
  if ($[27] !== t12) {
    t18 = <VStack align="center" flex={1} gap={10} justify="center" marginY={t12}>{t16}{t17}</VStack>;
    $[27] = t12;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  let t19;
  if ($[29] !== isMobile) {
    t19 = !isMobile && <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" flex={1} justify="center" position="relative"><Box bgImage="radial-gradient({colors.cyan.muted}, transparent 70%)" height="700px" position="absolute" width="700px" /><Image alt="Brian Chesky Cutout" objectFit="contain" src={require("@public/assets/graphics/social/brian-chesky-cutout-2.png").default.src} width="full" zIndex={1} /><Box height="full" left={0} position="absolute" top={0} width="full"><Image alt="AirBnB Logo" height="full" objectFit="contain" opacity={0.1} src={require("@public/assets/graphics/client-logos/airbnb-logo-white.svg").default.src} width="full" /></Box></Flex>;
    $[29] = isMobile;
    $[30] = t19;
  } else {
    t19 = $[30];
  }
  let t20;
  if ($[31] !== t11 || $[32] !== t18 || $[33] !== t19) {
    t20 = <Stack align="center" direction={t11} gap={0} justify="center" width="full">{t18}{t19}</Stack>;
    $[31] = t11;
    $[32] = t18;
    $[33] = t19;
    $[34] = t20;
  } else {
    t20 = $[34];
  }
  let t21;
  if ($[35] !== isMobile || $[36] !== isTablet) {
    t21 = isMobile || isTablet ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofFeatureCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/elonmusk-social.jpg").default.src} title="Elon Musk, Serial Founder, Tesla, SpaceX" /><SocialProofFeatureCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/stewarbutterfield-social.jpg").default.src} title="Stewart Butterfield, Founder, Slack" /><SocialProofFeatureCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/danielek-social-2.jpg").default.src} title="Daniel Ek, Founder, Spotify" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full"><SocialProofFeatureCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/elonmusk-social.jpg").default.src} title="Elon Musk, Serial Founder, Tesla, SpaceX" /><SocialProofFeatureCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/stewarbutterfield-social.jpg").default.src} title="Stewart Butterfield, Founder, Slack" /><SocialProofFeatureCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/danielek-social-2.jpg").default.src} title="Daniel Ek, Founder, Spotify" /></HStack>;
    $[35] = isMobile;
    $[36] = isTablet;
    $[37] = t21;
  } else {
    t21 = $[37];
  }
  let t22;
  if ($[38] !== t20 || $[39] !== t21) {
    t22 = <VStack align="start" gap={0} justify="center" maxWidth="container.xl" width="full">{t20}{t21}</VStack>;
    $[38] = t20;
    $[39] = t21;
    $[40] = t22;
  } else {
    t22 = $[40];
  }
  let t23;
  if ($[41] !== getBreakpointValue) {
    t23 = getBreakpointValue(["column-reverse", "column-reverse", "row"]);
    $[41] = getBreakpointValue;
    $[42] = t23;
  } else {
    t23 = $[42];
  }
  let t24;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <Box bgImage="radial-gradient({colors.blue.muted}, transparent 70%)" height="700px" position="absolute" width="700px" />;
    $[43] = t24;
  } else {
    t24 = $[43];
  }
  let t25;
  if ($[44] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <Image alt="Matt Mullenweg Cutout" objectFit="contain" src={require("@public/assets/graphics/social/mattmullenweg-cutout-reverse.png").default.src} width="full" zIndex={1} />;
    $[44] = t25;
  } else {
    t25 = $[44];
  }
  let t26;
  if ($[45] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = {
      _light: "invert(1) saturate(0)",
      _dark: "invert(0) saturate(1)"
    };
    $[45] = t26;
  } else {
    t26 = $[45];
  }
  let t27;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t27 = <Flex align="center" alignSelf="stretch" borderRadius="md" direction="column" justify="center" position="relative" width="full">{t24}{t25}<Box height="full" left={0} position="absolute" top={0} width="full"><Image alt="Wordpress Logo" filter={t26} height="full" objectFit="contain" opacity={0.1} src={require("@public/assets/graphics/client-logos/wordpress-logo.svg").default.src} width="full" /></Box></Flex>;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  let t28;
  if ($[47] !== getBreakpointValue) {
    t28 = getBreakpointValue(["3xl", "4xl", "4xl", "5xl", "6xl"]);
    $[47] = getBreakpointValue;
    $[48] = t28;
  } else {
    t28 = $[48];
  }
  let t29;
  if ($[49] !== getBreakpointValue) {
    t29 = getBreakpointValue(["center", "center", "left"]);
    $[49] = getBreakpointValue;
    $[50] = t29;
  } else {
    t29 = $[50];
  }
  let t30;
  if ($[51] !== t28 || $[52] !== t29) {
    t30 = <Heading color="red.fg" lineHeight="110%" size={t28} textAlign={t29} zIndex={5}>And created detailed Masterclasses for our Founders</Heading>;
    $[51] = t28;
    $[52] = t29;
    $[53] = t30;
  } else {
    t30 = $[53];
  }
  let t31;
  if ($[54] !== t23 || $[55] !== t30) {
    t31 = <Stack align="center" direction={t23} gap={10} justify="center" maxWidth="container.xl" width="full">{t27}{t30}</Stack>;
    $[54] = t23;
    $[55] = t30;
    $[56] = t31;
  } else {
    t31 = $[56];
  }
  let t32;
  if ($[57] !== isMobile || $[58] !== isTablet) {
    t32 = isMobile || isTablet ? <CardCarousel fade={false} spacing="0" visibleCards={[1]} controls={{
      top: false,
      bottom: MobileBottomControl
    }}><SocialProofMasterclassCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/steveblank-social.jpg").default.src} title="Steve Blank, Serial Founder, Lean Startup, Customer Development" /><SocialProofMasterclassCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/mattmullenweg-social.png").default.src} title="Matt Mullenweg, Founder, Wordpress" /><SocialProofMasterclassCard aspectRatio={isTablet ? "16/9" : "4/3"} bgImage={require("@public/assets/graphics/social/neilpatel-social.png").default.src} title="Neil Patel, Founder, Neil Patel SEO" /></CardCarousel> : <HStack align="center" gap={4} justify="center" width="full"><SocialProofMasterclassCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/steveblank-social.jpg").default.src} title="Steve Blank, Serial Founder, Lean Startup, Customer Development" /><SocialProofMasterclassCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/mattmullenweg-social.png").default.src} title="Matt Mullenweg, Founder, Wordpress" /><SocialProofMasterclassCard aspectRatio="4/3" bgImage={require("@public/assets/graphics/social/neilpatel-social.png").default.src} title="Neil Patel, Founder, Neil Patel SEO" /></HStack>;
    $[57] = isMobile;
    $[58] = isTablet;
    $[59] = t32;
  } else {
    t32 = $[59];
  }
  let t33;
  if ($[60] !== t31 || $[61] !== t32) {
    t33 = <VStack align="center" gap={0} justify="center" marginTop={20} width="full">{t31}{t32}</VStack>;
    $[60] = t31;
    $[61] = t32;
    $[62] = t33;
  } else {
    t33 = $[62];
  }
  let t34;
  if ($[63] !== t10 || $[64] !== t2 || $[65] !== t22 || $[66] !== t33) {
    t34 = <VStack align="center" borderRadius="3xl" boxShadow="inset 0 1px 0 rgba(255, 255, 255, 0.2)" gap={0} height="full" justify="stretch" overflow="hidden" padding={t2} width="full" bgImage="linear-gradient({colors.purple.solid/50}, transparent, transparent, {colors.purple.solid/50})">{t10}{t22}{t33}</VStack>;
    $[63] = t10;
    $[64] = t2;
    $[65] = t22;
    $[66] = t33;
    $[67] = t34;
  } else {
    t34 = $[67];
  }
  return t34;
};